import { render, staticRenderFns } from "./recalculo_tarifa.vue?vue&type=template&id=04ba8c66&"
import script from "./recalculo_tarifa.vue?vue&type=script&lang=js&"
export * from "./recalculo_tarifa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports